import { AppState, Dispatch } from '../../../../types'
import { LogPointsConnectorsState } from './model'
import { connect } from 'react-redux'
import LogPointsApplicationsBody, { EventProps, ExternalValueProps, ValueProps } from './LogPointsApplicationsBody'
import selectors from './selectors'
import * as actions from './actions'

const mapStateToProps = (state: AppState, ownProps: ExternalValueProps): ValueProps => ({
  ...ownProps,
  logPointsConnectors: selectors.logPointsConnectors(state),
  logPointsConnectorsLoading: selectors.logPointsConnectorsLoading(state),
  connectorsLoading: state.monitoring.logPoints.connectors.isFetching,
  resource: state.monitoring.logPoints.resourceSelector.selected,
  isSaving: selectors.isSaving(state),
  hasSavedYet: selectors.hasSavedYet(state),
  error: selectors.error(state)
})

const mapDispatchToProps = (dispatch: Dispatch): EventProps => ({
  fetchConnectors: (environmentId: string, resourceId: string, targetId?: string) =>
    dispatch(actions.fetchLogPointsConnectors(environmentId, resourceId, targetId)),
  save: (props: ExternalValueProps, logPointsConnectors: LogPointsConnectorsState) =>
    dispatch(actions.saveLogPointsConnectors(props, logPointsConnectors)),
  resetErrorAndSaved: () => dispatch(actions.resetConnectorsErrorAndSaved())
})

export default connect(mapStateToProps, mapDispatchToProps)(LogPointsApplicationsBody)
